import { useState, useEffect } from 'react';

const useFormState = (initState, { form, key }) => {
  const [formState, setFormState] = useState(initState);

  useEffect(() => {
    // 데이터 fetching 으로 인해 변경된 값 넣기
    setFormState(initState);
  }, [initState]);

  useEffect(() => {
    form.setFieldsValue({ [key]: formState });
  }, [formState]);

  return [formState, setFormState];
};

export default useFormState;
